<!-- 一般ユーザー　マイページ-->
<style src="@/assets/css/common_parts_input.css" type="text/css" media="all" scoped></style>
<style src="@/assets/css/common_parts_price.css" type="text/css" media="all" scoped></style>
<style src="@/assets/css/common_parts_reservation.css" type="text/css" media="all" scoped></style>
<style src="@/assets/css/common_parts_mypage.css" type="text/css" media="all" scoped></style>

<style scoped>

</style>
<template>
  <div class="container" id="myPage">
    <div class="contents">
      <h2>マイページ</h2>
      <section id="mainContents">
        <section class="confirmArea">
				  <div class="btnLst">
				  	<button class="confBtn" v-if="isDisplayReserveButton" v-on:click="onReserveKojin">健保制度を<b>利用せず</b><span>個人として新規予約</span></button>
				  	<button class="confBtn" v-on:click="onReserveHealth">健保制度を<b>利用して</b><span>新規予約</span></button>
				  </div>
          <dl class="myList">
            <dt>
              <ul class="tab">
                <li><label name="wakuRadio"><input type="radio" name="wakuRadio" v-bind:value="inputForm.codeEnableReserveData" v-model="inputForm.reserveDataFlag"><span>現在の予約</span></label></li>
							  <li><label name="wakuRadio"><input type="radio" name="wakuRadio" v-bind:value="inputForm.codeDisableReserveData" v-model="inputForm.reserveDataFlag"><span>キャンセル済・過去の予約</span></label></li>
              </ul>
            </dt>
            <dd class="now" v-show="isEnableReserveDataFlag">
              <!-- 有効な予約情報 -->
              <section class="reservation" v-for="item in enableReserveDataList" v-bind:key="item.ukno">
                <h3 class="ukNo"><span>予約番号</span>{{item.ukno}}</h3>
							  <ul class="date"><li>{{item.reserveDateYear}}<!--年--></li><li>{{item.reserveDateMonth}}<!--月--></li><li>{{item.reserveDateDate}}<!--日--></li><li>{{item.reserveSthm}}<!--時間--></li></ul>
							  <ul class="btnLst">
							  	<li><button class="detailBtn" v-on:click="onReserveDetail(item.ukno)">予約<span>詳細</span></button></li>
							  	<li><button class="detailBtn" v-on:click="onSendConfirmMail(item.ukno)">確認メール<span>送信</span></button></li>
							  	<li v-if="isChangeCancel(item.reserveDateYear,item.reserveDateMonth,item.reserveDateDate,currentDate,chdy)"><button class="backBtn" v-on:click="onReserveChange(item.ukno)">予約<span>変更</span></button></li>
							  	<li v-if="isChangeCancel(item.reserveDateYear,item.reserveDateMonth,item.reserveDateDate,currentDate,chdy)"><button class="cancelBtn" v-on:click="onReserveCancel(item.ukno)">予約<span>キャンセル</span></button></li>
							  </ul>
							  <dl class="plan">
							  	<dt>{{item.ksnm}}</dt>
							  		<dd class="option">
                      <b>追加オプション</b>
                      <ul>
                        <li v-for="optionName in item.optionNameList" v-bind:key="optionName">{{optionName}}</li>
                      </ul>
                    </dd>
							  </dl>
							  <div class="price">
							  	<p class="total">
                    <template v-if="item.kshj=='1'">
                      合計金額
                      <b>
                        {{item.money | moneyDelimiter}}
                        <span v-if="taxk=='1'">（税抜）</span>
                        <span v-else>（税込）</span>
                      </b>
                    </template>
                  </p>
							  </div>
              </section>
              <section v-if="enableReserveDataList.length == 0">
                <p>現在予約はありません</p>
              </section>
            </dd>
					  <!--キャンセル済・過去の予約 一覧-->
					  <dd class="old" v-show="!isEnableReserveDataFlag">
              <section class="reservation" v-for="item in disableReserveDataList" v-bind:key="item.ukno">
                <h3 class="ukNo"><span>予約番号</span>{{item.ukno}}</h3>
							  <ul class="date"><li>{{item.reserveDateYear}}<!--年--></li><li>{{item.reserveDateMonth}}<!--月--></li><li>{{item.reserveDateDate}}<!--日--></li><li>{{item.reserveSthm}}<!--時間--></li></ul>
							  <ul class="btnLst">
							  	<li><button class="detailBtn" v-on:click="onReserveDetail(item.ukno)">予約<span>詳細</span></button></li>
							  </ul>
							  <dl class="plan">
							  	<dt>{{item.ksnm}}</dt>
							  		<dd class="option">
                      <b>追加オプション</b>
                      <ul>
                        <li v-for="optionName in item.optionNameList" v-bind:key="optionName">{{optionName}}</li>
                      </ul>
                    </dd>
							  </dl>
                <div class="ykstComment">
                  <p v-if="checkDisableReserveDataType(item.ykst)=='0'">
                    受診済みまたは期限切れの予約です
                  </p>
                  <p v-if="checkDisableReserveDataType(item.ykst)=='1'">
                    変更済みの予約です
                  </p>
                  <p v-if="checkDisableReserveDataType(item.ykst)=='2'">
                    キャンセル済みの予約です
                  </p>
                </div>
							  <div class="price">
							  	<p class="total">
                    <template v-if="item.kshj=='1'">
                      合計金額
                      <b>
                        {{item.money | moneyDelimiter}}
                        <span v-if="taxk=='1'">（税抜）</span>
                        <span v-else>（税込）</span>
                      </b>
                    </template>
                  </p>
							  </div>
              </section>
              <section v-if="disableReserveDataList.length == 0">
                <p>キャンセル済・過去の予約はありません</p>
              </section>
            </dd>
          </dl>
        </section>
      </section>
      <!-- △ mainContents END -->
      <!-- モーダルWindow S -->
      <modalWindow v-show="modal.mailSendStart.isShow" v-on:close="onMailSendStartModalClose">
        <dt slot="modal-header">メール送信中</dt>
        <dd slot="modal-body">
          <errorMessageBox :errorMessages="modal.mailSendStart.messages"></errorMessageBox>
        </dd>
        <dd slot="modal-footer"></dd>
      </modalWindow>
      <!-- モーダルWindow E -->
      <!-- モーダルWindow S -->
      <modalWindow v-show="modal.mailSendComplete.isShow" v-on:close="onMailSendCompleteModalClose">
        <dt slot="modal-header">メール送信完了</dt>
        <dd slot="modal-body">
          <errorMessageBox :errorMessages="modal.mailSendComplete.messages"></errorMessageBox>
        </dd>
        <dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onMailSendCompleteModalClose">閉じる</a></dd>
      </modalWindow>
      <!-- モーダルWindow E -->
      <!-- モーダルWindow S -->
      <modalWindow v-show="modal.systemError.isShow" v-on:close="onSystemErrorModalClose">
        <dt slot="modal-header">システムエラー</dt>
        <dd slot="modal-body">
          <errorMessageBox :errorMessages="modal.systemError.messages"></errorMessageBox>
        </dd>
        <dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onSystemErrorModalClose">閉じる</a></dd>
      </modalWindow>
      <!-- モーダルWindow E -->
    </div>
  </div>
</template>
<script>
  import { CommonMyPage } from '@/api'
  import * as types from '@/store/mutation-types'
  import * as ErrorCodes from '@/components/Utility/error-codes'
  import ErrorMessageBox from '@/components/Utility/ErrorMessageBox'
  import ModalWindow from '@/components/Utility/ModalWindow'
  import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

  export default {
    // モジュール名
    name: 'CommonMyPage',
    // 使用コンポーネント
    components: {
      // エラー表示コンポーネント
      errorMessageBox: ErrorMessageBox,
      // モーダルウィンドウ表示コンポーネント
      modalWindow: ModalWindow
    },
    // 算出プロパティ
    computed: {
      // 「健保制度を利用せず個人として新規予約」ボタンを表示するフラグ
      // ture:  表示する
      // false: 表示しない
      isDisplayReserveButton: function() {
        return (this.codeNwkbBoth == this.nwkb)
          || (this.codeNwkbKojin == this.nwkb)
      },
      // 「健保制度を利用して新規予約」ボタンを表示するフラグ
      // ture:  表示する
      // false: 表示しない
      isDisplayReserveHealth: function() {
        return (this.codeNwkbBoth == this.nwkb)
          || (this.codeNwkbKenpo == this.nwkb)
      },
      // 有効な予約データを表示するフラグ
      // ture:  有効な予約データを表示する
      // false: 無効な予約データを表示する
      isEnableReserveDataFlag: function () {
        return this.inputForm.codeEnableReserveData
          == this.inputForm.reserveDataFlag
      }
    },
    // データ
    data() {  
      return {
        
        // 入力フォーム
        inputForm: {

          // 有効な予約データか無効なデータのどちらをタブで表示するか
          // 0: 有効な予約データを表示
          // 1: 無効なデータを表示
          reserveDataFlag: '0',
          codeEnableReserveData: '0',
          codeDisableReserveData: '1',
        },

        // 現在日付（Webサーバー時間）
        currentDate: '',
        // 消費税区分(1:外税 2:内税)
        taxk: '',
        // 予約区分(1:個人予約＋健保予約 2:個人予約 3:健保予約)
        nwkb: '',
        codeNwkbBoth: '1',
        codeNwkbKojin: '2',
        codeNwkbKenpo: '3',
        // 予約変更・キャンセル許可「　」日前まで可能
        chdy: '',
        // クライアントコード（受診者情報）
        jgcd: '',
        // 保険者番号（受診者情報）
        hksh: '',
        // 性別（受診者情報）
        sex: '',
        // 生年月日 年（受診者情報）
        btdyYear: 0,
        // 生年月日 月（受診者情報）
        btdyDate: 0,
        // 生年月日 日（受診者情報）
        btdyDate: 0,
        // 年度
        nend: 0,
        // 年齢
        age: 0,
        // 対象者区分（受診者情報）
        hfkb: '',
        // 有効な予約情報
        // ukno: 予約受付番号
        // reserveDateYear: 予約確定日 年
        // reserveDateMonth: 予約確定日 月
        // reserveDateDate: 予約確定日 日付
        // reserveSthm: 予約時間帯
        // ksnm: コース名
        // jgcd: クライアントコード
        // kshj: 金額表示(0:非表示 1:表示)
        // hfkb: 対象者区分コード
        // optionNameList: オプション名リスト
        // money: 金額
        enableReserveDataList: [],
        // 無効な予約情報
        // ukno: 予約受付番号
        // reserveDateYear: 予約確定日 年
        // reserveDateMonth: 予約確定日 月
        // reserveDateDate: 予約確定日 日付
        // reserveSthm: 予約時間帯
        // ksnm: コース名
        // jgcd: クライアントコード
        // kshj: 金額表示(0:非表示 1:表示)
        // hfkb: 対象者区分コード
        // optionNameList: オプション名リスト
        // money: 金額
        disableReserveDataList: [],

        // モーダルウィンドウ
        modal: {
          mailSendStart: {
            messages: [
              'メール送信中です。'
            ],
            isShow: false
          },
          mailSendComplete: {
            messages: [
              'メール送信完了しました。'
            ],
            isShow: false
          },
          systemError: {
            messages: [
							'システムエラーです。',
							'内容をもう一度ご確認ください。'
						],
            isShow: false
          }
        }
      }
    },
    // フィルター
    filters: {
      // 金額表示用三桁ごとにカンマをつける
      moneyDelimiter: function(value) {

        if(value == null) {
          return ''
        }
        
        return value.toLocaleString()
      }
    },
    // ライフサイクルフック: created
    created: function () {
      UtilityConsoleLog.consoleLog('CommonMyPage::created Start')

      this.firstDisplay()

      UtilityConsoleLog.consoleLog('CommonMyPage::created End')
    },
    methods: {
      // 初期表示
      firstDisplay: function () {
        UtilityConsoleLog.consoleLog('CommonMyPage::firstDisplay Start')

        // 初期化用のデータを取得する
        CommonMyPage.FirstDisplay({
          token: this.$store.state.auth.token,
          ircd: this.$store.state.auth.ircd,
          jgcd: this.$store.state.commonUserInfo.newHealthInsurance.jgcd,
          trsq: this.$store.state.auth.trsq
        }).then(({ responce })=>{
          if(responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

            this.currentDate = responce.data.currentDate
            this.taxk = responce.data.taxk
            this.nwkb = responce.data.nwkb
            this.chdy = responce.data.chdy
            this.jgcd = responce.data.jgcd
            this.hksh = responce.data.hksh
            this.sex = responce.data.sex
            this.btdyYear = responce.data.btdyYear
            this.btdyMonth = responce.data.btdyMonth
            this.btdyDate = responce.data.btdyDate
            this.nend = responce.data.nend
            this.age = responce.data.age
            this.hfkb = responce.data.hfkb
            this.enableReserveDataList = responce.data.enableReserveDataList
            this.disableReserveDataList = responce.data.disableReserveDataList

            this.$store.commit(
              types.COMMON_MYPAGE_FIRSTDISPLAY)

          } else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
            || responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
            || responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
            this.onSystemErrorModalOpen()
          }

        }).catch(() => {
          this.onSystemErrorModalOpen()
        }).finally(() => {
	        UtilityConsoleLog.consoleLog('CommonMyPage::firstDisplay End')
	      })
      },
      // 健保制度を利用せず個人として新規予約ボタン押下時
      onReserveKojin: function() {
        UtilityConsoleLog.consoleLog('CommonMyPage::onReserveKojin Start')

        // 個人の性別、年齢等をストアに保存する
        this.$store.commit(
          types.COMMON_MYPAGE_RESERVEKOJIN,
          {
            jgcd: this.jgcd,
            hksh: this.hksh,
            sex : this.sex,
            btdyYear : this.btdyYear,
            btdyMonth : this.btdyMonth,
            btdyDate : this.btdyDate,
            nend: this.nend,
            age: this.age,
            hfkb: this.hfkb
          })

        // コース選択に遷移
        this.$router.push("/CommonSelectCourse")

        UtilityConsoleLog.consoleLog('CommonMyPage::onReserveKojin End')
      },
      // 健保制度を利用して新規予約
      onReserveHealth: function() {
        UtilityConsoleLog.consoleLog('CommonMyPage::onReserveHealth Start')

        var tempJgcd = ''
        var tempHksh = ''
        var tempNend = 0
        var tempHfkb = ''

        if('00000000' != this.jgcd) {
          tempJgcd = this.jgcd
          tempHksh = this.hksh
          tempNend = this.nend
          tempHfkb = this.hfkb
        }

        // 個人の性別、年齢等をストアに保存する
        this.$store.commit(
          types.COMMON_MYPAGE_RESERVEHELTH,
          {
            jgcd: tempJgcd,
            hksh: tempHksh,
            sex : this.sex,
            btdyYear : this.btdyYear,
            btdyMonth : this.btdyMonth,
            btdyDate : this.btdyDate,
            nend: tempNend,
            age: this.age,
            hfkb: tempHfkb
          })

        // 新規健保予約に遷移
        this.$router.push("/CommonNewHealthInsurance")

        UtilityConsoleLog.consoleLog('CommonMyPage::onReserveHealth End')
      },
      // 予約詳細ボタン押下時 
      onReserveDetail: function (in_ukno) {
        UtilityConsoleLog.consoleLog('CommonMyPage::onReserveDetail Start')

        // 予約詳細ボタンが押された予約の予約受付番号を登録
        this.$store.commit(
          types.COMMON_MYPAGE_RESERVEDETAIL,
          {
            detailUkno: in_ukno
          })

        // 予約情報詳細に遷移
        this.$router.push("/CommonReserveDetail") 

        UtilityConsoleLog.consoleLog('CommonMyPage::onReserveDetail End')
      },
      // 確認メール送信ボタン押下時 
      onSendConfirmMail: function (in_ukno) {
        UtilityConsoleLog.consoleLog('CommonMyPage::onSendConfirmMail Start')

        // メール送信中ダイアログを開く
        this.onMailSendStartModalOpen()

        // メール送信
        CommonMyPage.SendConfirmMail({
          token: this.$store.state.auth.token,
          ircd: this.$store.state.auth.ircd,
          userId: this.$store.state.auth.userId,
          ukno: in_ukno
        }).then(({ responce })=>{
          if(responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

            // メール送信中ダイアログを閉じる
            this.onMailSendStartModalClose()

            // メール送信完了ダイアログを表示
            this.onMailSendCompleteModalOpen()

          } else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
            || responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
            || responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {

            this.onSystemErrorModalOpen()
          }
        }).catch(() => {
          this.onSystemErrorModalOpen()
        }).finally(() => {
          UtilityConsoleLog.consoleLog('CommonMyPage::onSendConfirmMail End')
        })

      },
      // 予約変更ボタン押下時
      onReserveChange: function (in_ukno) {
        UtilityConsoleLog.consoleLog('CommonMyPage::onReserveChange Start')

        // 予約受付番号からコースのクライアントコードを取得
        var tempReserveDataArray = this.enableReserveDataList.filter(
          (x) => x.ukno == in_ukno
        )

        if(tempReserveDataArray.length != 1) {
          // :TODO システムエラーにしたほうが良いかも
          return
        }

        // 予約受付番号を登録
        this.$store.commit(
          types.COMMON_MYPAGE_RESERVECHANGE,
          {
            choiceUkno: in_ukno,
            jgcd: tempReserveDataArray[0].jgcd,
            hksh: this.hksh,
            sex : this.sex,
            btdyYear : this.btdyYear,
            btdyMonth : this.btdyMonth,
            btdyDate : this.btdyDate,
            nend: tempReserveDataArray[0].nend,
            age: this.age,
            hfkb: tempReserveDataArray[0].hfkb,
          })

        // コース選択に遷移
        this.$router.push("/CommonSelectCourse") 

        UtilityConsoleLog.consoleLog('CommonMyPage::onReserveChange End')
      },
      // 予約キャンセルボタン押下時
      onReserveCancel: function (in_ukno) {
        UtilityConsoleLog.consoleLog('CommonMyPage::onReserveCancel Start')

        // 予約受付番号を登録
        this.$store.commit(
          types.COMMON_MYPAGE_RESERVECANCEL,
          {
            cancelUkno: in_ukno
          })

        // コース選択に遷移
        this.$router.push("/CommonConfirmCancel") 

        UtilityConsoleLog.consoleLog('CommonMyPage::onReserveCancel End')
      },
      // 現在の予約欄の予約変更及びキャンセルボタンを表示するかどうか
      isChangeCancel: function(
      	in_reserveDateYear,in_reserveDateMonth,in_reserveDateDate,
      	in_currentDate,in_chdy) {

        var resultFlag = true 
        
      	var tempReserveDate = new Date(
      		in_reserveDateYear,
      		in_reserveDateMonth - 1,
      		in_reserveDateDate)

      	var tempChdyDate = tempReserveDate
      	tempChdyDate.setDate(tempReserveDate.getDate() + in_chdy)

      	var tempCrurrentDate = new Date(in_currentDate)

        if(tempChdyDate >= tempCrurrentDate) {
          resultFlag = true
        } else {
          resultFlag = false
        }

        return resultFlag
      },
      // 無効な予約の種類を判定して返す
      // 0: 期限切れ（受診日が現在日付より後の日付）の予約
      // 1: 変更済みの予約
      // 2: キャンセル済みの予約
      checkDisableReserveDataType(in_ykst) {
        
        // 予約の種類
        var resultType = '0'

        // 31 : 変更済（確定式 確認未）及び32 : 変更済（確定式 確認済）の場合
        if('31' == in_ykst || '32' == in_ykst ) {
          resultType = '1'
        }

        // 91 : キャンセル済（確認未）及び92 : キャンセル済（確認済）及び
        // 99 : キャンセル済（削除済）の場合
        if('91' == in_ykst || '92' == in_ykst || '99' == in_ykst ) {
          resultType = '2'
        }

        return resultType
      },
      // 送信中モーダルとしてモーダルを開く
      onMailSendStartModalOpen: function () {
        UtilityConsoleLog.consoleLog('CommonMyPage::onMailSendCompleteModalOpen Start')

        this.modalOpen('mailSendStart')

        UtilityConsoleLog.consoleLog('CommonMyPage::onMailSendCompleteModalOpen End')
      },      
      // 送信中モーダルを閉じる
      onMailSendStartModalClose: function () {
        UtilityConsoleLog.consoleLog('CommonMyPage::onMailSendCompleteModalClose Start')

        this.modalClose('mailSendStart')

        UtilityConsoleLog.consoleLog('CommonMyPage::onMailSendCompleteModalClose End')
      },
      // 送信完了モーダルとしてモーダルを開く
      onMailSendCompleteModalOpen: function () {

        UtilityConsoleLog.consoleLog('CommonMyPage::onMailSendCompleteModalOpen Start')

        this.modalOpen('mailSendComplete')

        UtilityConsoleLog.consoleLog('CommonMyPage::onMailSendCompleteModalOpen End')
      },
      // 送信完了モーダルを閉じる
      onMailSendCompleteModalClose: function () {
        UtilityConsoleLog.consoleLog('CommonMyPage::onMailSendCompleteModalClose Start')

        this.modalClose('mailSendComplete')

        UtilityConsoleLog.consoleLog('CommonMyPage::onMailSendCompleteModalClose End')
      },
      // システムエラーモーダルとしてエラーモーダルを開く
      onSystemErrorModalOpen: function () {

        UtilityConsoleLog.consoleLog('CommonMyPage::onSystemErrorModalOpen Start')

        this.modalOpen('systemError')

        UtilityConsoleLog.consoleLog('CommonMyPage::onSystemErrorModalOpen End')
      },
      // システムエラーモーダルを閉じる
      onSystemErrorModalClose: function () {
        UtilityConsoleLog.consoleLog('CommonMyPage::onSystemErrorModalClose Start')

        this.modalClose('systemError')

				// URLパラム
				var tempParam = this.$store.getters.getCommonParam

				// トップ画面へ遷移
				this.$router.push('/CommonTop/' + tempParam)

        UtilityConsoleLog.consoleLog('CommonMyPage::onSystemErrorModalClose End')
      },
      // モーダルウィンドウを開く
      modalOpen: function (modalName) {

        UtilityConsoleLog.consoleLog('CommonMyPage::modalOpen Start')

				// すべてのモーダルを閉じる
				this.allModalClose()

        this.modal[modalName].isShow = true

        UtilityConsoleLog.consoleLog('CommonMyPage::modalOpen End')
      },
      // モーダルウィンドウを閉じる
      modalClose: function (modalName) {

        UtilityConsoleLog.consoleLog('CommonMyPage::modalClose Start')

        this.modal[modalName].isShow = false

        UtilityConsoleLog.consoleLog('CommonMyPage::modalClose End')
      },
			// 全てのモーダルを閉じる
			allModalClose: function() {  
				for(var key in this.modal) {
					this.modal[key].isShow = false
				}
			}
      // その他--------------------------------------------------E
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/MyPage/CommonMyPage.vue